// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UNUS","label":"styles_label__1B0Ws"};